import { getSystemEnv } from '@/utils/env'

declare global {
  interface Window {
    dataLayer?: unknown[]
    gtag?: (...args: unknown[]) => void
  }
}

export const GA_MEASUREMENT_ID = getSystemEnv().GA_MEASUREMENT_ID

export const pageview = (url: string): void => {
  if (typeof window.gtag !== 'function') return
  window.gtag('config', GA_MEASUREMENT_ID, { page_path: url })
}

export const event = (
  action: string,
  params?: Record<string, unknown>
): void => {
  if (typeof window.gtag !== 'function') return
  window.gtag('event', action, params)
}
